import { CoreText } from '@/components/Theme/Core/CoreText';
import { withStyles } from '@/components/Theme/Core/withStyles';
import { motify } from 'moti';

export const ThemeMotiText = withStyles(motify(CoreText)(), {type: 'ThemeText'});